import { html, ViewTemplate, ref, repeat } from '@microsoft/fast-element';
import type { ProjectVppaCard } from './project-vppa-card';
import { VPPA_RFQ_STATUS } from '../../../utils';
import { normalChevron } from '../../../styles';
import { VPPA_COLUMNS } from './column-config';
import { getFormattedNumber } from '../../../utils/formatting';

export const ProjectVppaCardTemplate: ViewTemplate<ProjectVppaCard> = html`
  <div>
    <div
      class="${(x) => (x.isSelected ? 'project-card project-card-selected' : 'project-card')}"
      @click=${(x) => x.projectSelected()}
    >
      <div style="display:flex;">
        <div class="icon">
          <span>${(x) => x.getTechnologyIcon()}</span>
        </div>
        <div class="content">
          <div class="project-header-container">
            <p class="project-name" @click=${(x) => x.openProjectPage()}>
              ${(x) => x.project?.NAME}
            </p>
          </div>
          <p class="project-legal-name">
            ${(x) => x.project?.CASCADE_COMPANY_NAME.toUpperCase()} |
            ${(x) => getFormattedNumber(x.project?.MEGAWATT_AC)} MW | ${(x) => x.project?.ISO}
          </p>
        </div>
      </div>
      <div class="button-container">
        <zero-button
          class="${(x) =>
            x.gridVisibility && x.numberOfRows > 0
              ? 'chevron-control-button rotate-icon'
              : 'chevron-control-button'}"
          @click="${(x, c) => {
            c.event.stopPropagation();
            x.switchGridVisibility();
          }}"
          ?disabled="${(x) => x.numberOfRows === 0}"
        >
          ${(x) => x.numberOfRows} ${normalChevron('end')}
        </zero-button>
      </div>
    </div>

    <div
      class="vppa-grid"
      style="height: ${(x) => x.gridHeight}; display: ${(x) =>
        x.gridVisibility && x.numberOfRows > 0 ? '' : 'none'}"
    >
      <zero-grid-pro
        class="grid-styles"
        only-template-col-defs
        sideBar=""
        @onGridReady="${(x) => x.onGridReady()}"
        :eventsAndCallbacks=${(x) => x.customEvents}
        ${ref('vppaGrid')}
      >
        <grid-pro-genesis-datasource
          resource-name="ALL_VPPA"
          criteria="PROJECT_ID == '${(x) =>
            x.project
              ?.PROJECT_ID}' && (VPPA_STATUS == '${VPPA_RFQ_STATUS.ACTIVE}' || VPPA_STATUS == '${VPPA_RFQ_STATUS.EXISTING_INTEREST}' ||  VPPA_STATUS == '${VPPA_RFQ_STATUS.AWAITING_KEY_METRICS}')"
        />
        ${repeat(
          (x) => VPPA_COLUMNS(),
          html`
            <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
          `,
        )}
      </zero-grid-pro>
    </div>
  </div>
`;
